module.exports = __webpack_public_path__ + "static/media/giphy-7.a878e5d7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-7.gif
// module id = 178
// module chunks = 0